import React from "react";

import styled from "styled-components/macro";

import { FnrPopover } from "UI/FnrPopover2";

/*
USAGE EXAMPLE:

import FnrConfirmationPopover from "UI/FnrConfirmationPopover";

<FnrConfirmationPopover
  show={showConfirmation}
  ref={triggerRef}
  onClose={() => setShowConfirmation(false)}
  message={<div>Are you sure?</div>}
  button1={
    <FnrButton
      text="Yes, cancel it!"
      onClick={handleCancelClick}
      color="blue"
      loading={status === "loading"}
    />
  }
  color="red"
  style={{ maxWidth: 200, padding: 10 }}
/>
*/

const FnrConfirmationPopover = React.forwardRef(
  ({ show, onClose, message, button1, button2, style, color }, ref) => (
    <FnrPopover
      show={show}
      buttonRef={ref}
      onShouldClose={onClose}
      style={style}
      color={color}
    >
      {message}
      <ButtonWrapper>
        {button1}
        {button2}
      </ButtonWrapper>
    </FnrPopover>
  )
);

FnrConfirmationPopover.displayName = FnrConfirmationPopover;
export default FnrConfirmationPopover;

const ButtonWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;
